<template>
    <div id="multiple">
        <el-scrollbar :class="isCollapse?'menu_hide rightSide':'rightSide'">
            <el-main>
                <nav-bar></nav-bar>
                <el-form ref="formselect" :model="formselect" label-width="80px" class="queryform_div">
                    <el-form-item :label="$t('Name')">
                        <el-input @keyup.enter.native="getData" v-model="formselect.name"></el-input>
                    </el-form-item>

                    <el-form-item :label="$t('Type')">
                        <el-select v-model="formselect.typeCode" :placeholder="$t('el.select.placeholder')" filterable class="queryform">
                            <el-option v-for="item in type" :key="item.comprehensiveSetCode"
                                       :value="item.comprehensiveSetCode"
                                       :label="item.comprehensiveSetName"></el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item>
                        <el-button @click="getData" type="primary">{{ $t('Query') }}</el-button>
                        <el-button @click="reset">{{ $t('Reset') }}</el-button>
                    </el-form-item>
                </el-form>
                <template>
                    <el-button type="primary" icon="el-icon-circle-plus-outline" @click="add"
                               v-if="judge('ComprehensiveSetting_Create')"
                               style="margin-bottom:10px;">{{ $t('Add') }}
                    </el-button>

                    <el-table ref="multipleTable"
                              :data="tableData1"
                              v-loading="loading"
                              border
                              stripe
                              style="width:100%;min-height:200px;">
                        <el-table-column type="index"
                                         :label="$t('SN')"
                                         width="50">
                        </el-table-column>
                        <el-table-column prop="typeName"
                                         :label="$t('Type')"
                                         min-width="10%">
                        </el-table-column>
                        <el-table-column prop="name"
                                         :label="$t('Name')"
                                         min-width="20%">
                        </el-table-column>
                        <el-table-column prop="functionGroupName"
                                         :label="$t('Functionalgroup')"
                                         min-width="20%">
                        </el-table-column>
                        <el-table-column prop="remark"
                                         :label="$t('Remarks')"
                                         min-width="40%">
                        </el-table-column>
                        <el-table-column fixed="right"
                                         :label="$t('Action')">
                            <template slot-scope="scope">
                                <el-button v-if="judge('ComprehensiveSetting_Update')" @click="edit(scope.row)" type="primary" size="small">
                                  {{ $t('Edit') }}</el-button>
                                <template v-if="judge('ComprehensiveSetting_Delete')">
                                    <el-popconfirm placement="top"
                                                   :confirmButtonText="$t('Delete')"
                                                   :cancelButtonText="$t('Cancel')"
                                                   @onConfirm="del(scope.row)"
                                                   icon="el-icon-info"
                                                   iconColor="red"
                                                   :title="$t('DeleteConfirm')">
                                        <el-button size="mini" type="danger" slot="reference"
                                                   style=" margin-left: 10px;">{{ $t('Delete') }}
                                        </el-button>
                                    </el-popconfirm>
                                </template>
                            </template>
                        </el-table-column>
                    </el-table>
                    <el-pagination
                            background
                            :page-size="10"
                            @current-change="handleCurrentChange"
                            layout="prev, pager, next"
                            :total="total">
                    </el-pagination>
                </template>

            </el-main>
        </el-scrollbar>
        <el-dialog :title="clickBtn=='add'? $t('Add') : $t('Update')" :visible.sync="dialogAddComposite" width="70%" top="10vh">
            <el-form ref="Compositeform" :model="Compositeform" label-width="150px">
                <el-form-item :label="$t('Type')" prop="typeCode" :rules="[{required: true, message: $t('PleaseSelectTheType')}]">
                    <el-select :placeholder="$t('el.select.placeholder')" style="width: 250px;" v-model="Compositeform.typeCode">
                        <el-option v-for="(item,index) in type"
                                   :key="'inx2'+index"
                                   :label="item.comprehensiveSetName"
                                   :value="item.comprehensiveSetCode">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item :label="$t('Code')" prop="code" :rules="[{required: true, message: $t('PleaseEnterTheCode')}]">
                    <el-input style="width: 250px;" v-model="Compositeform.code"></el-input>
                </el-form-item>
                <el-form-item :label="$t('Name')" prop="name" :rules="[{required: true, message: $t('PleaseEnterName')}]">
                    <el-input style="width: 250px;" v-model="Compositeform.name"></el-input>
                </el-form-item>
                <el-form-item :label="$t('Functionalgroup')" prop="functionGroupId" :rules="[{required: true, message: $t('PleaseEnterFunctionalGroup')}]"
                              v-if="Compositeform.typeCode=='Function'">
                    <el-select :placeholder="$t('el.select.placeholder')" style="width: 250px;" v-model="Compositeform.functionGroupId">
                        <el-option v-for="(item,index) in deptg"
                                   :key="'inx3'+index"
                                   :label="item.functionGroupName"
                                   :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item :label="$t('Remarks')">
                    <el-input style="width:70%;" type="textarea" v-model="Compositeform.remark"></el-input>
                </el-form-item>

                <el-form-item>
                    <el-button type="success" @click="onSubmit('Compositeform')">{{ $t('Confirm') }}</el-button>
                    <el-button @click="dialogAddComposite = false">{{ $t('Cancel') }}</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
    import {mapState} from 'vuex';
    import {
        GetAllComprehensiveSet,
        CreateComprehensiveSet,
        UpdateComprehensiveSet,
        GetAllFunctionGroup,
        GetComprehensiveTypes,
        DeleteComprehensiveSet
    } from '../../api/api'
    import {judgePermission} from '../../utils/util'
    export default {
        name: "multiple",
        data() {
            return {
                dialogAddComposite: false,
                isShowDept: false,
                loading: false,
                tableData1: [],
                formselect: {
                    typeCode: "",
                    name: ''
                },
                type: [
                    {
                        value: '1',
                        label: this.$t('Department')
                    }, {
                        value: '2',
                        label: this.$t('DepartmentGroup')
                    }, {
                        value: '3',
                        label: this.$t('Function')
                    }, {
                        value: '4',
                        label: this.$t('Grade')
                    }],
                Compositeform: {
                    id: "",
                    typeName: '',
                    typeCode: '',
                    code: '',
                    name: '',
                    functionGroupId: '',
                    remark: '',
                },
                deptg: [],
                currentPage: 0,
                total: 0,
                clickBtn: "",
            }
        },
        mounted() {
            this.FunctionGroup()
            this.ComprehensiveTypes()
            this.getData()
        },
        methods: {
            judge(e){
                return judgePermission(e)
            },
            reset() {
                this.formselect = {
                    typeCode: "",
                    name: ''
                }
                this.getData()
            },
            del(e) {
                var data = {
                    id: e.id,
                    TypeCode: e.typeCode
                }, that = this
                DeleteComprehensiveSet(data).then(res => {
                    if (res.success) {
                        that.$message.success("delete success")
                        that.getData()
                    } else {
                        that.$message.error("delete failed")
                    }
                })
            },
            add() {
                this.dialogAddComposite = true
                this.clickBtn = "add"
                this.Compositeform = {
                    id: "",
                    typeName: '',
                    typeCode: '',
                    code: '',
                    name: '',
                    functionGroupId: '',
                    remark: '',
                }
            },
            edit(e) {
                this.dialogAddComposite = true
                this.clickBtn = "edit"
                this.Compositeform = e
            },
            FunctionGroup() {
                var that = this
                GetAllFunctionGroup().then(res => {
                    if (res.success) {
                        that.deptg = res.result.items
                    }
                })
            },
            ComprehensiveTypes() {
                var that = this
                GetComprehensiveTypes().then(res => {
                    if (res.success) {
                        that.type = res.result
                    }
                })
            },
            handleCurrentChange(val) {
                this.currentPage = (val - 1) * 10
                this.getData()
            },
            //查询数据
            getData() {
                this.loading = true
                var that = this
                var data = this.formselect
                data.currentPage = this.currentPage

                GetAllComprehensiveSet(data).then(res => {
                    if (res.success) {
                        that.tableData1 = res.result.items
                        that.total = res.result.totalCount
                    } else {
                        that.$message.error(this.$t('QueryFailed'))
                    }
                    that.loading = false
                })
            },
            onSubmit(Compositeform) {
                this.$refs[Compositeform].validate(validate => {
                    if (validate) {
                        var that = this
                        this.type.map(i => {
                            if (this.Compositeform.typeCode == i.comprehensiveSetCode) {
                                this.Compositeform.typeName = i.comprehensiveSetName
                            }
                        })
                        var data = JSON.parse(JSON.stringify(this.Compositeform))
                        if (this.clickBtn == "add") {
                            delete data.id
                            CreateComprehensiveSet(data).then(res => {
                                if (res.success) {
                                    that.$message.success(this.$t('Creation'))
                                    that.dialogAddComposite = false
                                    that.getData()
                                    that.FunctionGroup()
                                } else {
                                    that.$message.error(this.$t('CreationFailed'))
                                }
                            })
                        } else {
                            UpdateComprehensiveSet(data).then(res => {
                                if (res.success) {
                                    that.$message.success(this.$t('Update'))
                                    that.dialogAddComposite = false
                                    that.getData()
                                } else {
                                    that.$message.error(this.$t('UpdateFailed'))
                                }
                            })
                        }
                    }
                })

            },

        },
        computed: mapState({
            isCollapse: state => state.isCollapse
        }),
    }
</script>

<style scoped>
    .multiple {
        margin-top: 5vh;
    }

    .Header {
        display: flex;
    }

    .select_input {
        width: 80%;
    }
</style>
